import React from "react"
import Skeleton from "react-loading-skeleton"
import DynamicSkeleton from "../../components/DynamicSkeleton"

const columnConfig = {
  ID: {content:<Skeleton height="20px" width="70px" />, center: true},
  "Station Detail": {content:<Skeleton height="64px" width="350px" />, center: false},
  Consumption: {content:<Skeleton height="20px" width="60px" />, center: true},
  Bookings: {content: <Skeleton height="20px" width="60px" />, center:true},
  Revenue: {content: <Skeleton height="20px" width="60px" />, center:true},
  "Available Ports": {content: <Skeleton height="30px" width="50px" />, center: true},
  Action: {
    content: (
      <div className="d-flex justify-content-center gap-2">
        <Skeleton height="30px" width="30px" />
        <Skeleton height="30px" width="30px" />
      </div>
    ),
    center: true,
  },
}

const ChargingStationListSkeleton = ({ infiniteScroll, rows = 6 }) => {
  return (
    <DynamicSkeleton
      rows={rows}
      columnConfig={columnConfig}
      infiniteScroll={infiniteScroll}
    />
  )
}

export default ChargingStationListSkeleton
